import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import {Alert} from "react-bootstrap";
import App from "./App";
import "./App.scss";
import configureStore from "./_redux/redux_store";
import {isIE} from 'react-device-detect';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {setDeferredPrompt} from "./install_prompt_cache";
import {forceReloadWithCacheBust} from "./_helpers/misc_functions";

window.addEventListener('error', (e) => {
  const isChunkLoadError =
    e?.message?.includes('ChunkLoadError') ||
    e?.error?.name === 'ChunkLoadError';

  if (isChunkLoadError) {
    console.warn('ChunkLoadError caught — forcing cache-busting reload...');
    forceReloadWithCacheBust();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  const isChunkLoadError =
    reason?.message?.includes('ChunkLoadError') ||
    reason?.name === 'ChunkLoadError';

  if (isChunkLoadError) {
    console.warn('Unhandled ChunkLoadError — forcing cache-busting reload...');
    forceReloadWithCacheBust();
  }
});


window.addEventListener("beforeinstallprompt", (e) => {
  // e.preventDefault(); // optional if you're showing a custom install button
  setDeferredPrompt(e);
});

export const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {isIE && <Alert variant={'danger'} >
        It seems you are using Internet Explorer. It is advised to use the latest version of Google Chrome, Mozilla Firefox, or Microsoft Edge when using this website.
      </Alert>}
      <App />
    </Provider>
  </React.StrictMode>);

serviceWorkerRegistration.register();